import React from "react";
import _ from "lodash";
import {
  FormGroup,
  FormLabel,
  FormControlLabel,
  Checkbox,
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
} from "@material-ui/core";
import { ExpandMore } from "@material-ui/icons";
import { regions, prefectures } from "helpers/location";

const RegionGroup = ({ region, selected, onChange, validPrefectures }) => {
  const items = prefectures.filter((p) => p.region === region.code);

  const handleChange = (e) => {
    const code = parseInt(e.target.name, 10);
    onChange(code, e.target.checked);
  };

  // validPrefecturesに入っていなくても、暗くするだけで設定自体はできるようにする

  return (
    <div>
      <FormLabel component="legend">{region.name}</FormLabel>
      <FormGroup row>
        {items.map((item) => (
          <FormControlLabel
            key={item.code}
            control={
              <Checkbox
                checked={selected.includes(item.code)}
                onChange={handleChange}
                name={item.code.toString()}
              />
            }
            label={item.name}
            style={
              validPrefectures.includes(item.code) ? {} : { color: "#aaa" }
            }
          />
        ))}
      </FormGroup>
    </div>
  );
};

export default ({ selectedValues, onChange, validPrefectures }) => {
  const handleChange = (code, value) => {
    if (value) {
      onChange(_.sortBy(_.uniq([...selectedValues, code])));
    } else {
      onChange(selectedValues.filter((v) => v !== code));
    }
  };

  return (
    <ExpansionPanel>
      <ExpansionPanelSummary
        expandIcon={<ExpandMore />}
        id="location-filter-header"
      >
        <div>
          地域で絞り込み (
          {selectedValues.length === 0
            ? "指定なし"
            : selectedValues
                .map((code) => prefectures.find((p) => p.code === code).name)
                .join(", ")}
          )
        </div>
      </ExpansionPanelSummary>
      <ExpansionPanelDetails>
        <div>
          {regions.map((region) => (
            <RegionGroup
              key={region.code}
              region={region}
              selected={selectedValues}
              onChange={handleChange}
              validPrefectures={validPrefectures}
            />
          ))}
        </div>
      </ExpansionPanelDetails>
    </ExpansionPanel>
  );
};
